import { useEffect, useLayoutEffect, useRef, useState } from "react";

export function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		widthOuter: window.outerWidth,
		heightOuter: window.outerHeight,
		widthInner: window.innerWidth,
		heightInner: window.innerHeight,
	});

	function resizeWindow() {
		setWindowSize({
			widthOuter: window.outerWidth,
			heightOuter: window.outerHeight,
			widthInner: window.innerWidth,
			heightInner: window.innerHeight,
		});
	}

	useLayoutEffect(() => {
		window.addEventListener("resize", resizeWindow);
		return () => {
			window.removeEventListener("resize", resizeWindow);
		};
	}, [window]);

	return windowSize;
}

export const useSearchEffect = (callback, search, inputRef, dependencies) => {
	const componentJustMounted = useRef(true);

	useEffect(() => {
		let timer = null;

		if (!componentJustMounted.current) {
			timer = setTimeout(() => {
				//debounce
				if (search === inputRef.current.value) {
					callback();
				}
			}, 500);
		}
		componentJustMounted.current = false;

		return () => {
			clearTimeout(timer);
		};
	}, dependencies);
};

export const useUpdateEffect = (callback, dependencies) => {
	const componentJustMounted = useRef(true);

	useEffect(() => {
		if (!componentJustMounted.current) {
			callback();
		}
		componentJustMounted.current = false;
	}, dependencies);
};
